// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top_level h1{font-size:var(--font-scale-10) !important}.body.svelte-r0qbz7.svelte-r0qbz7{display:flex}.body.svelte-r0qbz7>div.svelte-r0qbz7{width:20em}", ""]);
// Exports
module.exports = exports;
